import React from 'react';
import { Form, Input } from 'antd';
import api from '@/apis';

export default ({
  type = 'textArea',
  rows = '3',
  style = {},
  placeholder = '请输入ERP，多个ERP请用逗号隔开',
  label = 'erp',
  name = 'erps',
  message = '不能为空！',
  validateTrigger = 'onBlur',
  validator = () => Promise.resolve(),
  ...otherProps
}) => {
  return (
    <Form.Item
      validateTrigger={validateTrigger}
      label={label}
      name={name}
      validateFirst
      rules={[
        {
          required: true,
          message: message,
        },
        {
          validator: (_, value) => {
            return new Promise((resolve, reject) => {
              const erps = value && value.replace(/，/gi, ',');
              api
                .validateErp(erps)
                .then((res) => {
                  const { ret } = res;
                  if (ret === '0' && res.data) {
                    return resolve();
                  } else {
                    return reject(new Error(res.msg));
                  }
                })
                .finally(() => {
                  return resolve();
                });
            });
          },
        },
        {
          validator: validator,
        },
      ]}
      {...otherProps}
    >
      {type === 'textArea' ? (
        <Input.TextArea rows={rows} style={style} placeholder={placeholder} />
      ) : (
        <Input style={style} placeholder={placeholder} />
      )}
    </Form.Item>
  );
};
